import { Navigate } from 'react-router-dom'
import { useFamily } from '@/context/FamilyContext'

interface RequireWriterProps {
  children: React.ReactNode
}

export function RequireWriter({ children }: RequireWriterProps) {
  const { activeWriter, isLoading } = useFamily()

  // Show nothing while loading family data
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--color-kids-bg)]">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-[var(--color-kids-primary)] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-[var(--color-kids-text-muted)]">Loading...</p>
        </div>
      </div>
    )
  }

  // Redirect to writer selection if no active writer
  if (!activeWriter) {
    return <Navigate to="/select-writer" replace />
  }

  return <>{children}</>
}
